export default function register(theClass) {
  
  let $form = $(theClass);

  let messageField = $(`${theClass} .js-aldrich-form__message`);
  let errorClass = "aldrich-form__message--error";

  function validateEmail(email) {
    var re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(email);
  }

  $form.submit((e) => {
    e.preventDefault();
    let emailValue = $(`${theClass} .js-mailchimp-email`).val();
    if (validateEmail(emailValue)) {
      $.ajax({
        url: $form.attr("action"),
        data: $form.serialize(),
        cache: false,
        dataType: "jsonp",
        jsonp: "c",
        contentType: "application/json; charset=utf-8",
        error: function (err) {
          console.log(err);
        },
        success: function (data) {
          if (data.result != "success") {
            messageField.empty();
            messageField.addClass(errorClass).append(`Error! ${data.msg}`);
          } else {
            messageField.empty();
            messageField.removeClass(errorClass).append(`Success! ${data.msg}`);
            localStorage.setItem("interstitialEmailSeen", "true");
          }
        },
      });
    } else {
      messageField.empty();
      messageField.addClass(errorClass).append(`Please enter a valid email address`);
    }
  });
}
